import { infoItemPartLoadFailureMessage } from './createItemPartLoadFailureInfoBarMessage.locstring.json';
import { infoLinkClickHere } from 'owa-locstrings/lib/strings/infolinkclickhere.locstring.json';
import loc from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import Message from 'owa-service/lib/contract/Message';

import {
    InfoBarCustomAction,
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';

export default function createItemPartLoadFailureInfoBarMessage(
    message: Message,
    key: string,
    viewState: ItemViewState
): InfoBarMessageViewState {
    // If there aren't error properties or the length is 0, don't show the info bar
    if (!message.ErrorProperties || message.ErrorProperties.length == 0) {
        return null;
    }

    const openNewWindowAction: InfoBarCustomAction = {
        action: () => {
            popoutReadingPane(viewState.itemId);
        },
        text: loc(infoLinkClickHere),
    };

    return <InfoBarMessageViewState>{
        key: key,
        source: InfoBarMessageSource.ReadingPane,
        rank: InfoBarMessageRank.Info,
        color: InfoBarMessageColor.Grey,
        messageParts: [loc(infoItemPartLoadFailureMessage), openNewWindowAction],
    };
}
